import * as comlink from "comlink";

import type { GetDatasetsExpose, GetDatasetsOptions } from "../types";

export function getDatasets(options: GetDatasetsOptions) {
  const worker = new Worker(new URL("./data.worker.ts", import.meta.url), {
    type: "module",
  });

  const link = comlink.wrap<GetDatasetsExpose>(worker);
  return link.getDatasets(options);
}
